import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ListComponent = LoadComponentWithRetry(() => import('./ListComparisonPage'));
const AddComponent = LoadComponentWithRetry(() => import('./AddComparisonPage'));
const ViewComponent = LoadComponentWithRetry(() => import('./ViewComparisonPage'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/add`} component={AddComponent} />
      <Route path={`${path}/:comparison_uid`} component={ViewComponent} />
      <Route path={path} component={ListComponent} />
    </Switch>
  );
};

export default Routes;
